(() => {
  function init(scope = document) {
    scope.querySelectorAll('.nm-sidebar-v2').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      // Closed drawers must not compete with the visible page for image bandwidth.
      const images = root.querySelectorAll('[data-nm-menu-src]');
      const loadMenuImages = () => {
        root.querySelectorAll('[data-nm-menu-src]').forEach(img => {
          img.src = img.dataset.nmMenuSrc;
          delete img.dataset.nmMenuSrc;
        });
      };
      document.addEventListener('click', event => {
        if (event.target.closest('[data-action="toggle-nav"], .nm-menu-bookmark')) loadMenuImages();
      }, true);
      const imageObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const img = entry.target;
          if (getComputedStyle(img).visibility === 'hidden') return;
          if (img.dataset.nmMenuSrc) {
            img.src = img.dataset.nmMenuSrc;
            delete img.dataset.nmMenuSrc;
          }
          imageObserver.unobserve(img);
        });
      }, {rootMargin:'0px'});
      images.forEach(img => imageObserver.observe(img));
      const navigation = root.closest('nav');
      if (navigation) new MutationObserver(() => {
        root.querySelectorAll('[data-nm-menu-src]').forEach(img => {
          imageObserver.unobserve(img); imageObserver.observe(img);
        });
      }).observe(navigation, {attributes:true,attributeFilter:['class','style']});
      const home = root.querySelector('[data-sidebar-home]');
      const grid = root.querySelector('[data-sidebar-grid]');
      const show = root.querySelector('[data-sidebar-show]');
      const back = root.querySelector('[data-sidebar-back]');
      const scroller = root.closest('.navigation__menu-content');
      let savedScroll = 0;
      show.addEventListener('click', () => {
        savedScroll = scroller ? scroller.scrollTop : 0;
        home.hidden = true; grid.hidden = false;
        show.setAttribute('aria-expanded', 'true');
        if (scroller) scroller.scrollTop = 0;
        back.focus({preventScroll:true});
      });
      function goBack() {
        grid.hidden = true; home.hidden = false;
        show.setAttribute('aria-expanded', 'false');
        if (scroller) scroller.scrollTop = savedScroll;
        show.focus({preventScroll:true});
      }
      back.addEventListener('click', goBack);
      root.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !grid.hidden) {
          event.preventDefault(); event.stopPropagation(); goBack();
        }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
